import { render, staticRenderFns } from "./KitView.vue?vue&type=template&id=2cf0d122"
import script from "./KitView.vue?vue&type=script&lang=js"
export * from "./KitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports